import { Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { refreshToken } from '../services/auth';

const AuthMiddleware = ({ children }) => {
    const location = useLocation();
    const token = localStorage.getItem('authenticationToken');
    const publicRoutes = ['/', '/register'];
    const isPublicRoute = publicRoutes.includes(location.pathname);
    const isTokenExpired = (token) => {
        if (!token) return true;
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const currentTime = Date.now() / 1000;
            return payload.exp < currentTime;
        } catch (error) {
            return true;
        }
    };
    useEffect(() => {
        const checkAndRefreshToken = async () => {
            if (token && !isTokenExpired(token)) {
                const isRefreshed = await refreshToken();
                if (!isRefreshed) {
                    localStorage.removeItem('authenticationToken');
                    window.location.href = '/';
                }
            } else if (token && isTokenExpired(token)) {
                localStorage.removeItem('authenticationToken');
                window.location.href = '/';
            }
        };
        checkAndRefreshToken();
    }, [token]);
    if (!token && !isPublicRoute) {
        return <Navigate to="/" />;
    }
    if (token && isPublicRoute) {
        return <Navigate to="/dashboard" />;
    }
    return children;
};

export default AuthMiddleware;